export const defaultStripeElementErrors = {
  CCCVC: 'HIDDEN_CC_ERROR',
  CCExp: 'HIDDEN_CC_ERROR',
  CCNumber: 'HIDDEN_CC_ERROR',
};
